import { useState, useEffect } from 'react';
function useWindowSize() {
    function getSize() {
        return {
            width: window.innerWidth,
            height: window.innerHeight,
        };
    }
    var _a = useState(getSize), windowSize = _a[0], setWindowSize = _a[1];
    useEffect(function () {
        function handleResize() {
            setWindowSize(getSize());
        }
        window.addEventListener('resize', handleResize);
        window.addEventListener('orientationchange', handleResize);
        return function () {
            window.removeEventListener('resize', handleResize);
            window.removeEventListener('orientationchange', handleResize);
        };
    }, []);
    return windowSize;
}
export default useWindowSize;
//# sourceMappingURL=useWindowSize.js.map